"use client";

import { useEffect, useRef } from "react";
import parse from "html-react-parser";

const onPress = (e: Event) => {
  e.preventDefault();
  const target = (e.currentTarget as HTMLElement)?.getAttribute(
    "data-to-scrollspy-id",
  );
  const el = target ? document.getElementById(target) : null;
  if (el) {
    window.scrollTo({ top: el.offsetTop + 150, behavior: "smooth" });
  }
};

export default function BlogSidebar({
  titlesSection,
}: {
  titlesSection: string;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const links = Array.from(node.querySelectorAll("a"));
    links.forEach((link) => {
      link.removeAttribute("target");
      const parent = link.parentElement as HTMLElement | null;
      if (!parent) return;
      parent.addEventListener("click", onPress);
      const href = link.getAttribute("href");
      parent.setAttribute("data-to-scrollspy-id", href ? href.substring(1) : "");
      link.classList.add("block", "rounded-md", "p-1");
      link.style.textDecoration = "none";
    });
    return () => {
      links.forEach((link) => {
        const parent = link.parentElement as HTMLElement | null;
        if (parent) parent.removeEventListener("click", onPress);
      });
    };
  }, []);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const links = Array.from(node.querySelectorAll("a"));
    const handleScroll = () => {
      let current = "";
      const main = document.querySelector("main");
      if (!main) return;
      const elements = main.querySelectorAll("*");
      Array.from(elements).forEach((section) => {
        const s = section as HTMLElement;
        const sectionTop = s.offsetTop + 150;
        const sectionHeight = s.clientHeight || 10;
        if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
          current = s.getAttribute("id") || "";
        }
      });
      links.forEach((link) => {
        const linkHref = link.getAttribute("href")?.substring(1) ?? "";
        if (linkHref === current) {
          links.forEach((l) => l.classList.remove("sidebar-link-active"));
          link.classList.add("sidebar-link-active");
        }
      });
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div ref={ref} className="ql-snow" aria-labelledby="communities-headline">
      <div className="ql-editor px-0 space-y-2">{parse(titlesSection)}</div>
    </div>
  );
}
